import React, { useState, useEffect } from "react";
import ApiService from "../../../services/ApiService";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import { useAppContext } from "../../../context/AppContext";
import Toast from "../../../components/Toast";
import SectionLoader from "../../../components/SectionLoader";
import BackButton from '../../../components/BackButton';
import { getOrCreateDeviceId } from "../../../utils/deviceId";
import Swal from "sweetalert2";
import { isDriverVisibleMaterial } from "../../../utils/lineItemFilters";
interface ShippingAddress {
  address: string;
  city: string;
  state: string;
  zip: string;
}

const PickUp: React.FC = () => {
  const deliveryID = localStorage.getItem("delivery_id");
  const vendor_id = localStorage.getItem("vendor_id");
  const sales_order_id = localStorage.getItem("sales_order_id");
  const api_token = localStorage.getItem("_token");
  const navigate = useNavigate();
  const {
    salesOrder,
    purchaseOrder,
    delivery,
    setDelivery,
    materialfo,
    setPurchaseOrder,
    setToken,
    setSalesOrder,
    setLoads,
    setPhotos,
    setAttachments,
    setLoadItems,
    setMeterialSo,
    setMaterialfo,
    setProgressDeliveries,
  } = useAppContext();
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Fresh data fetch on load
  useEffect(() => {
    if (!api_token || !sales_order_id) {
      setIsLoading(false);
      return;
    }
     // ← ADD THESE 4 LINES HERE
  // If no active delivery exists, clear any stale picked-up material
  if (!deliveryID) {
    localStorage.removeItem("picked_up_material");
  }
    let isMounted = true;
    const fetchFreshData = async () => {
      if (delivery && delivery.id && delivery.status) {
        setIsLoading(false);
        return;
      }
      if (vendor_id && sales_order_id) {
        try {
          const deviceId = getOrCreateDeviceId();
          const responseData = await ApiService.getFreshData({
            vendor_id: vendor_id,
            sales_order_id: sales_order_id,
            delivery_id: deliveryID || null,
            token: false,
            device_id: deviceId,
          });
          if (!isMounted) return;
          if (responseData && responseData.success) {
            setPurchaseOrder(responseData.data.purchase_order);
            setToken(responseData.api_token);
            setDelivery(responseData.data.delivery);
            setLoads(responseData.data.loads);
            setLoadItems(responseData.data.item_loads);
            setPhotos(responseData.data.photos || []);
            setAttachments(responseData.data.attachments || []);
            setSalesOrder(responseData.data.sales_order);
            setMeterialSo(responseData.data.meterial_so);
            setMaterialfo(responseData.data.material_fo);
            setProgressDeliveries(responseData.data.progress);
          }
        } catch (error: any) {
          console.error("Error fetching fresh data:", error);
        } finally {
          if (isMounted) {
            setIsLoading(false);
          }
        }
      } else {
        setIsLoading(false);
      }
    };
    fetchFreshData();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveryID]);

  const [toast, setToast] = useState<{
    message: string;
    type: "success" | "error";
    duration?: number;
  } | null>(null);

  if (isLoading || !purchaseOrder) return <SectionLoader />;

  let shippingAddress: ShippingAddress | null = null;
  if (purchaseOrder && purchaseOrder.shipping_address) {
    try {
      if (typeof purchaseOrder.shipping_address === "string") {
        shippingAddress = JSON.parse(purchaseOrder.shipping_address);
      } else if (typeof purchaseOrder.shipping_address === "object") {
        shippingAddress = purchaseOrder.shipping_address;
      }
    } catch (error) {
      console.error("Invalid shipping_address format:", error);
    }
  }

  const fullAddress = `${shippingAddress?.address}, ${shippingAddress?.city}, ${shippingAddress?.state} ${shippingAddress?.zip}`;

  // ─── All materials on this PO (excluding "Load" unit) ───
//   const allMaterials = (purchaseOrder?.po_data?.line_items ?? []).filter(
//   (item: any) => item.unit !== "Load"
// );

// console.log("Line items structure:", purchaseOrder?.po_data?.line_items); // ← add this
// ─── Only real materials on this PO (hides service, misc, trucking, fuel surcharges) ───
  const allMaterials = (purchaseOrder?.po_data?.line_items ?? []).filter(
    isDriverVisibleMaterial
  );
  const handleOpenMap = () => {
    const encoded = encodeURIComponent(fullAddress);
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/i.test(ua)) {
      Swal.fire({
        title: "Choose Map App",
        text: "Select which map application you'd like to use",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Google Maps",
        denyButtonText: "Apple Maps",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#4285F4",
        denyButtonColor: "#007AFF",
        cancelButtonColor: "#6c757d",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = `https://www.google.com/maps?q=${encoded}`;
        } else if (result.isDenied) {
          window.location.href = `http://maps.apple.com/?q=${encoded}`;
        }
      });
    } else if (/Android/i.test(ua)) {
      const mapUrl = `geo:0,0?q=${encoded}`;
      window.location.href = mapUrl;
      const fallback = setTimeout(() => {
        window.open(`https://www.google.com/maps?q=${encoded}`, "_blank");
      }, 1000);
      window.addEventListener("pagehide", () => clearTimeout(fallback));
    } else {
      window.open(`https://www.google.com/maps?q=${encoded}`, "_blank");
    }
  };

  const pickupInfo = {
    deliveryNotes: salesOrder?.special_instructions || "",
    productName: allMaterials[0]?.description || "",
    QuarryName: purchaseOrder?.po_data?.vendor_name,
    poNumber: '#' + purchaseOrder?.po_number,
    description: allMaterials[0]?.description || "",
    unit: allMaterials[0]?.unit || "TON",
    quantity: (() => {
      const poQty = allMaterials.reduce(
        (t: number, item: any) => t + (parseFloat(item.quantity) || 0),
        0
      );
      return poQty > 0 ? poQty.toFixed(2) : "0.00";
    })(),
    Address: (
      <ul>
        <li><strong> Address: </strong> {shippingAddress?.address || "N/A"}</li>
        <li><strong>City: </strong> {shippingAddress?.city || "N/A"}</li>
        <li><strong>State: </strong> {shippingAddress?.state || "N/A"}</li>
        <li><strong>ZipCode: </strong> {shippingAddress?.zip || "N/A"}</li>
      </ul>
    ),
  };

  // ─── Ask driver which material(s) they loaded ───
  // Popup only appears when there are MULTIPLE materials on the PO.
  // With a single material, it auto-selects silently (no popup).
  const askPickedUpMaterials = async (): Promise<string[] | null> => {
    // Single material → auto-select, no popup
    if (allMaterials.length === 1) {
      return [allMaterials[0].description || allMaterials[0].name || "Material"];
    }

    // No materials → nothing to select
    if (allMaterials.length === 0) {
      return [];
    }

    // Multiple materials → show popup with checkboxes
    // const checkboxesHtml = allMaterials
    //   .map((item: any, index: number) => {
    //     const name = item.description || item.name || `Material ${index + 1}`;
    //     const safeName = name.replace(/"/g, "&quot;");
    //     return `
    //       <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; padding: 12px; border: 2px solid #e0e0e0; border-radius: 8px; background: #fafafa; margin-bottom: 8px;">
    //         <input name="material" type="radio" class="swal-material-checkbox" value="${safeName}" style="width: 20px; height: 20px; accent-color: #E07B00; cursor: pointer; flex-shrink: 0;" />
    //         <span style="font-weight: 500; color: #333; font-size: 14px; text-align: left;">${name}</span>
    //       </label>
    //     `;
    //   })
    //   .join("");
    const checkboxesHtml = allMaterials
      .map((item: any, index: number) => {
        const name = item.description || item.name || `Material ${index + 1}`;
        const safeName = name.replace(/"/g, "&quot;");
        return `
          <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; padding: 12px; border: 2px solid #e0e0e0; border-radius: 8px; background: #fafafa; margin-bottom: 8px;">
            <input type="checkbox" class="swal-material-checkbox" value="${safeName}" style="width: 20px; height: 20px; accent-color: #E07B00; cursor: pointer; flex-shrink: 0;" />
            <span style="font-weight: 500; color: #333; font-size: 14px; text-align: left;">${name}</span>
          </label>
        `;
      })
      .join("");

    const result = await Swal.fire({
      title: "Which material did you load?",
      html: `
        <div style="text-align: left; margin-top: 10px;">
          <p style="color: #666; font-size: 14px; margin-bottom: 16px;">
            Check off the material(s) you have loaded onto your truck:
          </p>
          ${checkboxesHtml}
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#E07B00",
      cancelButtonColor: "#6c757d",
      reverseButtons: true,
      preConfirm: () => {
        const checked = Array.from(
          document.querySelectorAll(".swal-material-checkbox:checked")
        ) as HTMLInputElement[];
        if (checked.length === 0) {
          Swal.showValidationMessage("Please select at least one material");
          return false;
        }
        return checked.map((c) => c.value);
      },
    });

    if (!result.isConfirmed) return null;
    return result.value as string[];
  };

  const MaterialLoaded = async () => {
    // Use delivery from context or fallback to localStorage
    const currentDeliveryId = delivery?.id || deliveryID;
    if (!currentDeliveryId) {
      setToast({
        message: "Delivery ID not found. Please refresh the page.",
        type: "error",
      });
      return;
    }

    // If delivery already moved past "assigned", skip popup and just navigate forward
    if (delivery && delivery.status && delivery.status !== 'assigned') {
      navigate('/upload-weight-ticket');
      return;
    }

    // Ask which material(s) were loaded BEFORE setting loading state
    const selectedMaterials = await askPickedUpMaterials();
    if (selectedMaterials === null) {
      // User cancelled the popup
      return;
    }

    setButtonLoading(true);

    const vendor_id = localStorage.getItem("vendor_id");
    let responseData = null;
    try {
      responseData = await ApiService.materialLoaded({
        delivery_id: currentDeliveryId,
        vendor_id: vendor_id || null,
        picked_up_material: selectedMaterials.length > 0 ? selectedMaterials : null,
      });
      // if (responseData && responseData.success) {
      //   setToast({
      //     message: responseData.message || "Material loaded, proceed to next step",
      //     type: "success",
      //   });
      //   setDelivery(responseData.data);
      //   setTimeout(() => {
      //     localStorage.setItem('page', 'upload-weight-ticket');
      //     navigate("/upload-weight-ticket");
      //   }, 500);
      // }
      if (responseData && responseData.success) {
  setToast({
    message: responseData.message || "Material loaded, proceed to next step",
    type: "success",
  });
  setDelivery(responseData.data);

  // Persist the driver's selected materials for later screens (weight ticket, signature, etc.)
  localStorage.setItem("picked_up_material", JSON.stringify(selectedMaterials));

  setTimeout(() => {
    localStorage.setItem('page', 'upload-weight-ticket');
    navigate("/upload-weight-ticket");
  }, 500);
}
       else {
        setToast({ message: responseData.message, type: "error" });
        setButtonLoading(false);
      }
    } catch (error: any) {
      setToast({
        message: error.message || "Something went wrong",
        type: "error",
      });
      setButtonLoading(false);
      console.error("Error starting delivery:", error);
    }
  };

  const CancelDelivery = async () => {
    const result = await Swal.fire({
      title: "Cancel Delivery?",
      text: "Are you sure you want to cancel this delivery? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Cancel Delivery",
      cancelButtonText: "No, Keep It",
    });
    if (!result.isConfirmed) return;

    setButtonLoading(true);
    const currentDeliveryId = delivery?.id || deliveryID;

    if (!currentDeliveryId) {
      setToast({
        message: "Delivery ID not found. Please refresh the page.",
        type: "error",
      });
      setButtonLoading(false);
      return;
    }

    try {
      const deviceId = getOrCreateDeviceId();
      const responseData = await ApiService.cancelDelivery({
        delivery_id: currentDeliveryId,
        vendor_id: vendor_id || null,
        device_id: deviceId,
      });
      if (responseData && responseData.success) {
        setToast({
          message: responseData.message || "Delivery cancelled successfully",
          type: "success",
        });
        // setDelivery(null);
        // localStorage.removeItem("delivery_id");
setDelivery(null);
localStorage.removeItem("delivery_id");
localStorage.removeItem("picked_up_material"); // ← add this


        const freshData = await ApiService.getFreshData({
          vendor_id: vendor_id,
          sales_order_id: sales_order_id,
          delivery_id: null,
          token: false,
          device_id: deviceId,
        });
        if (freshData && freshData.success) {
          setPurchaseOrder(freshData.data.purchase_order);
          setToken(freshData.api_token);
          setDelivery(freshData.data.delivery);
          setLoads(freshData.data.loads);
          setLoadItems(freshData.data.item_loads);
          setPhotos(freshData.data.photos || []);
          setAttachments(freshData.data.attachments || []);
          setSalesOrder(freshData.data.sales_order);
          setMeterialSo(freshData.data.meterial_so);
          setMaterialfo(freshData.data.material_fo);
          setProgressDeliveries(freshData.data.progress);
        }
        setTimeout(() => {
          navigate("/");
        }, 500);
        setButtonLoading(false);
      } else {
        setToast({
          message: responseData.message || "Failed to cancel delivery",
          type: "error",
        });
        setButtonLoading(false);
      }
    } catch (error: any) {
      console.error("Error cancelling delivery:", error);
      const parsed = error.message ? JSON.parse(error.message || {}) : {};
      setToast({
        message: parsed?.message || "Failed to cancel delivery. Please try again.",
        type: "error",
      });
      setButtonLoading(false);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <div className="col-lg-9 col-12 content-area pick-up justify-content-center">
            <div className="row m-0 py-1 justify-content-center">
              <div className="col-12 mb-1 mt-1">
                <BackButton />
              </div>
              <div className="col-md-12 mb-1">
                <div className="h-100 card-dark px-lg-5 px-3 py-2">
                  <h4 className="mb-2 fw-bold">Material Pickup Location</h4>
                  <div className="d-flex">
                    <h6 className="secondary-text text-one-line">Quarry Name :</h6>
                    <p className="ms-2 me-0">{pickupInfo?.QuarryName}</p>
                  </div>
                  <div className="d-md-flex d-block billing-address">
                    <h6 className="secondary-text text-one-line">Quarry Address :</h6>
                    {pickupInfo?.Address}
                  </div>

                  {/* ─── Product: show single OR list all when multiple ─── */}
              {allMaterials.length <= 1 ? (
  <div className="d-flex billing-address">
    <h6 className="secondary-text text-one-line">Product : </h6>&nbsp;
    {pickupInfo?.productName}
  </div>
) : (
  <div className="dss-material-list mt-2 mb-2">
    <h6 className="secondary-text mb-2 fw-bold">DSS Material:</h6>
    {allMaterials.map((item: any, index: number) => (
      <div key={index} className="dss-material-row">
        <span className="dss-material-name">
          <strong>Material {index + 1}:</strong>{" "}
          {item.description || item.name}
        </span>
        <span className="dss-material-qty">
          {parseFloat(item.quantity || 0).toFixed(2)} {item.unit || "TON"}
        </span>
      </div>
    ))}
  </div>
)}

                 <div className="dss-total-row">
  <span className="dss-total-label fw-bold">Total Quantity</span>
  <span className="dss-total-qty">
    {pickupInfo?.quantity} {pickupInfo?.unit}
  </span>
</div>
                  <div className="d-flex billing-address">
                    <h6 className="secondary-text text-one-line">Please reference DSS PO: </h6>&nbsp;
                    {pickupInfo?.poNumber}
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex row mt-1 mb-2 m-auto flex-wrap align-items-center justify-content-center gap-3">
              <div className="col-md-6 col-12">
                <button onClick={handleOpenMap} className="btn-light-orange w-100">
                  Pickup Location Map
                </button>
              </div>
              <div className="col-md-6 col-12">
                <button
                  disabled={buttonLoading}
                  onClick={() => MaterialLoaded()}
                  className="btn-orange w-100"
                >
                  {buttonLoading && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  I have loaded the material
                </button>
              </div>
              {delivery && delivery?.status && delivery?.status !== "open" && delivery?.status !== "completed" && (
                <div className="col-md-6 col-12">
                  <button
                    disabled={buttonLoading}
                    onClick={() => CancelDelivery()}
                    className="btn-light-orange w-100"
                    style={{
                      backgroundColor: "#dc3545",
                      borderColor: "#dc3545",
                      color: "white",
                    }}
                  >
                    {buttonLoading && (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    Cancel Load
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};

export default PickUp;